<template>
    <div class="box">
        <h3>优质招标企业</h3>
        <ul>
            <li v-for="(item,index) in data.adenterprise" :key="item.adtitle"
                v-czc="['交易中心','点击列表', '优质招标企业' , index+1 ,`tradeCenter-list-adenterprise`]">
                <el-tooltip
                    :disabled="item.adtitle.length < 13"
                    class="item"
                    effect="dark"
                    :content="item.adtitle"
                    placement="top-start"
                >
                    <el-button
                        type="text"
                        class="adtitle"
                        @click.stop.prevent="adsClickHandler(item)"
                        >{{ item.adtitle }}</el-button
                    >
                </el-tooltip>

                <el-link type="info" :underline="false" class="rate">综合分值{{item.compositescore}}分</el-link>
                <el-link type="info" :underline="false" class="rate">信用分值{{item.creditscore}}分</el-link>
                <el-link type="info" :underline="false" class="rate">服务分值{{item.servicescore}}分</el-link>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState({
            data: (state) => {
                return state.dealcenter.data;
            },
        }),
    },
    methods: {
        adsClickHandler(item) {
            var href = item.linkurl;

            this.$get(`${this.$store.state.api.webUrl}/admessage/clicklog.json`, {
                adguid: item.adguid
            });

            if (href) {
                window.open(href);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.box {
    float: left;
    box-sizing: border-box;
    width: 592px;
    background-color: white;
    margin-left: 15px;
    padding-top: 30px;
    padding-left: 21px;
    margin-bottom: -999px;
    padding-bottom: 999px;

    h3 {
        font-size: 16px;
        margin-bottom: 30px;
    }
    ul {
        list-style-type: none;
        padding: 0px;
        margin: 0px;
        padding-bottom: 6px;

        li {
            font-size: 14px;
            background-repeat: no-repeat;
            background-position: 0px 9px;
            padding-left: 14px;
            line-height: 1em;
            margin-bottom: 1em;
            position: relative;

            &:before{
                content: '';
                display: block;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background: #d2d2d2;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }

    .adtitle {
        display: block;
        box-sizing: border-box;
        float: left;
        width: 170px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #333;
        margin-right: 100px;
        padding: 0;
        text-align: left;
    }
    .adtitle:hover {
        color: #3d7eff;
    }
    .rate {
        margin-right:2px ;
        color: #666;
    }

    .rate:nth-child(4){
        margin-right:22px;
    }
    
}
</style>
